export const ALNUM_HYPHEN_UNDERSCORE_PATTERN = '^[a-zA-Z0-9-_]+$';
